import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const ServerApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "SrvrApp" */ "./ServerApp");
    return { default: namedExport.ServerApp };
});

export const Server: TeamAppConfig = {
    title: "Server",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    path: "/server",
    description: "The server app",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: ServerApp
};
